@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.many-modal {
  width: 100%;
  max-width: 1370px;
  min-width: 905px;
}
.modal-body {
  padding: 0;
  font-size: 13px;
  line-height: 15px;
  overflow: hidden;
  height: 100%;
}

.error-message {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.modal-footer {
  .mark-shipped-button {
    margin-left: 10px;
  }
}

.content-container {
  > * {
    padding-top: 10px;
    padding-left: 20px;
  }
}

.bulk-title {
  margin-bottom: 10px;
  font-weight: 800;
}

.bulk-body {
  height: 500px;
  padding: 15px;
  font-size: 14px;
  display: grid;
  grid-template:
    'instructions instructions'
    'select-area .'
    'paste-area error-area';
  grid-template-rows: 80px 70px 300px;
  grid-template-columns: 1fr 2fr;
  gap: 10px;
  overflow-y: hidden;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  .tooltip-target-wrapper {
    margin: 9px 20px 0 0;
    fill: @mark-as-shipped--tooltip--fill-color;
    width: 30px;
    height: 30px;
    > svg {
      transform: scale(0.5);
      height: 30px;
      width: 30px;
    }
    &:hover {
      cursor: pointer;
    }
  }
}

.bulk-paste-container {
  grid-area: paste-area;
  display: flex;
  flex-direction: column;
  div:first-child {
    flex-grow: 1;
    margin-bottom: 10px;
    textarea::placeholder {
      color: @mark-as-shipped--bulk-paste--text-color;
    }
  }
}

.bulk-error-container {
  grid-area: error-area;
}

.bulk-errors {
  overflow-y: auto;
  max-height: calc(100% - 20px);
}

.bulk-select-container {
  grid-area: select-area;
  justify-content: space-evenly;
}

.bulk-select-button {
  width: 300px;
}

.bulk-instructions {
  grid-area: instructions;
  > div {
    margin-bottom: 10px;
  }
}

.error {
  padding: 3px 10px;
}

.tooltip-text-span {
  display: block;
  margin-bottom: 10px;
}

.restricted-orders-info {
  margin: 10px 0;
  width: 730px;
  max-width: 90%;
  margin-left: 20px;
}
